/**
 * Snapshot module-code resolver.
 *
 * Same algorithm as `resolveModuleCode` in the admin hook but operates on
 * just the questionId/familyId pair (no Question object needed). Snapshots
 * are produced from `PipelineBatchResult` which doesn't carry the full
 * Question — and we don't want to import from the content domain to keep
 * the snapshot module self-contained inside `governance/pipeline`.
 */
export function resolveModuleCodeForSnapshot(questionId: string, familyId: string): string {
  // Family id is usually the most reliable hint when present
  const source = familyId || questionId;
  const parts = source.split('-');
  if (parts[0] === 'TGL' && parts.length >= 2) {
    if (parts[1] === 'GELD') return 'GELD';
    if (parts[1] === 'TIJD') return 'TIJD';
  }
  return parts[0] || 'UNKNOWN';
}